/** Minimum interval between automatic segment→timeline pulls (ms). */
export const VIDEO_EDITOR_SEGMENT_SYNC_INTERVAL_MS = 4 * 60 * 1000;

const AUTO_SEGMENT_SYNC_STORAGE_KEY = 'tt-video-editor-auto-segment-sync';

/** Default on: pull new segment images/audio from Mongo into the open timeline. */
export function readVideoEditorAutoSegmentSyncEnabled() {
  try {
    const raw = localStorage.getItem(AUTO_SEGMENT_SYNC_STORAGE_KEY);
    if (raw === '0' || raw === 'false') return false;
    return true;
  } catch {
    return true;
  }
}

export function writeVideoEditorAutoSegmentSyncEnabled(enabled) {
  try {
    localStorage.setItem(AUTO_SEGMENT_SYNC_STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore quota */
  }
}

export function segmentSyncThrottleElapsed(lastSyncAtMs, now = Date.now()) {
  if (!lastSyncAtMs) return true;
  return now - lastSyncAtMs >= VIDEO_EDITOR_SEGMENT_SYNC_INTERVAL_MS;
}
